module.exports = __webpack_public_path__ + "static/media/wc_info_slider_1.63c3821b.svg";